<template>
  <div>
    <v-card-text class="py-0">
      <div style='display: flex;'>
        <numberForm
          label="最小数"
          v-model="regulationItem.rules.minimumFrequency"
        ></numberForm>
        <keywordRankForm
          v-model="regulationItem.rules.targetRank"
        ></keywordRankForm>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import numberForm from './forms/numberForm'
import keywordRankForm from './forms/keywordRankForm'

export default {
  name: 'IntroductionKeywordFrequency',
  components: {
    numberForm,
    keywordRankForm
  },
  props: {
    regulationItem: {
      type: Object,
      required: true
    }
  }
}
</script>
